module.exports = __webpack_public_path__ + "static/img/pin-multi-active.8f6ce48.svg";